import { useEffect, useRef, useSyncExternalStore } from 'react'
import { useLocation } from 'react-router-dom'
import { applyUpdate, isFormRoute, isUpdateReady, onUpdateReady } from '../lib/appUpdate'
import { Icon } from './Icon'

/**
 * Tells the user a new version is deployed. It applies itself on the next navigation to a page without a field
 * form (so nothing being typed is lost); "Actualizar" applies it right away.
 */
export function UpdateBanner() {
  const ready = useSyncExternalStore(onUpdateReady, isUpdateReady, () => false)
  const { pathname } = useLocation()
  const shown = useRef(pathname)
  useEffect(() => {
    if (!ready) { shown.current = pathname; return }
    if (pathname !== shown.current && !isFormRoute(pathname)) applyUpdate()
    shown.current = pathname
  }, [ready, pathname])
  if (!ready) return null
  return (
    <div role="status" className="offline-bar update-bar">
      <Icon name="refresh" size={16} />
      <span>Hay una nueva versión de la aplicación.</span>
      <button type="button" className="btn btn--primary btn--sm" onClick={() => applyUpdate()}>Actualizar</button>
    </div>
  )
}
